import {
  Box,
  TableCell,
  TableCellProps,
  Typography,
  useTheme,
} from "@mui/material";
import { ReactNode } from "react";
type XGroupCellProps = TableCellProps & {
  headerTitle: ReactNode;
};
export const XGroupCell = ({
  headerTitle,
  ...tableCellProps
}: XGroupCellProps) => {
  const theme = useTheme();
  return (
    <TableCell {...tableCellProps} style={{ paddingBottom: 0, paddingTop: 0 }}>
      <Box sx={{ margin: 1 }}>
        <Typography
          variant="subtitle1"
          gutterBottom
          component="div"
          fontWeight={theme.typography.fontWeightMedium}
        >
          {headerTitle}
        </Typography>
        {tableCellProps.children}
      </Box>
    </TableCell>
  );
};
